import React from 'react';
import { Shield, Security, Visibility, Lock } from '@mui/icons-material';
import PageHero from '../components/common/PageHero';
import PageLayout from '../components/common/PageLayout';
import ContentSection from '../components/common/ContentSection';
import ContactSection from '../components/common/ContactSection';

const PrivacyPolicyPage = () => {
    const sections = [
        {
            title: "Information We Collect",
            icon: <Visibility />,
            content: [
                "Account information (email, display name) when you register",
                "Images you upload for waste classification (processed and deleted immediately)",
                "Classification history and results for your personal tracking",
                "Usage data to improve our AI model accuracy",
                "Device and browser information for security purposes"
            ]
        },
        {
            title: "How We Use Your Information",
            icon: <Security />,
            content: [
                "Process and classify your waste images using our AI model",
                "Maintain your personal classification history and statistics",
                "Improve our machine learning algorithms (anonymized data only)",
                "Send important account notifications and updates",
                "Provide customer support when needed"
            ]
        },
        {
            title: "Data Protection",
            icon: <Lock />,
            content: [
                "All uploaded images are processed in real-time and immediately deleted",
                "Your personal data is encrypted and stored securely",
                "We never share your personal information with third parties",
                "You can delete your account and all associated data anytime",
                "We comply with international data protection standards"
            ]
        },
        {
            title: "Your Rights",
            icon: <Shield />,
            content: [
                "Access and download your personal data",
                "Correct or update your account information",
                "Delete your account and all associated data",
                "Opt-out of non-essential communications",
                "Request information about how your data is used"
            ]
        }
    ];

    return (
        <PageLayout
            showIntroduction={true}
            introTitle="🌍 Our Commitment to Your Privacy"
            introContent={
                <>
                    At Sortify, we believe in transparency and protecting your privacy. This policy explains
                    how we collect, use, and safeguard your information when you use our AI-powered waste
                    classification platform. We are committed to maintaining the highest standards of data
                    protection while helping you make environmentally responsible decisions.
                    <br/><br/>
                    By using Sortify, you agree to the practices described in this Privacy Policy.
                    If you have any questions, please contact us at <strong>support@sortifi.org</strong>.
                </>
            }
        >
            <PageHero
                title="Privacy Policy"
                subtitle="Your privacy is our priority. Learn how we protect your data."
                emoji="🔒"
                badge={`Last updated: ${new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`}
            />

            {/* Main Sections */}
            {sections.map((section, index) => (
                <ContentSection
                    key={index}
                    title={section.title}
                    icon={section.icon}
                    content={section.content}
                />
            ))}

            {/* Contact Section */}
            <ContactSection />
        </PageLayout>
    );
};

export default PrivacyPolicyPage;
